import { render } from "./newzealand.vue?vue&type=template&id=dd114338"
import script from "./newzealand.vue?vue&type=script&lang=js"
export * from "./newzealand.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__